module.exports = __webpack_public_path__ + "img/screenshot_n_12.7398064b.png";